import { useEffect, useState } from "react";
import axios from "axios";
import { Zap } from "lucide-react";

const fmtVol = (v) => {
  if (v == null) return "—";
  if (v >= 1000000) return `$${(v / 1000000).toFixed(1)}M`;
  if (v >= 1000) return `$${Math.round(v / 1000)}K`;
  return `$${Math.round(v)}`;
};

const fmtTime = (epoch) => {
  const d = new Date(epoch * 1000);
  const date = d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  return { date, time };
};

export const StormHistory = () => {
  const [history, setHistory] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/storm/history`);
        if (alive) setHistory(data.history || []);
      } catch {
        /* keep last */
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <section
      id="storm-history"
      data-testid="storm-history"
      className="relative z-10 max-w-3xl mx-auto px-4 sm:px-8 pt-16 sm:pt-24 pb-6 text-left"
    >
      <div className="mb-8 text-center">
        <p className="font-bebas tracking-[0.35em] text-[#9945FF] text-lg">RECEIPTS</p>
        <h2
          data-testid="storm-history-heading"
          className="font-marker text-4xl sm:text-5xl gradient-sol text-glow-green mt-2 -rotate-1 inline-block"
        >
          STORM HISTORY
        </h2>
        <p className="font-marker text-zinc-500 mt-3">every tier upgrade, timestamped.</p>
      </div>

      <p className="font-bebas tracking-[0.3em] text-zinc-500 text-sm text-center flex items-center justify-center gap-2">
        <Zap size={14} className="text-[#9945FF]" /> LIVE TIER LOG <Zap size={14} className="text-[#14F195]" />
      </p>
      {history === null ? (
        <p className="text-zinc-600 text-xs text-center mt-4">Reading the skies…</p>
      ) : history.length === 0 ? (
        <p data-testid="storm-history-empty" className="text-zinc-600 text-xs text-center mt-4">
          No storms recorded yet — the skies are calm. For now.
        </p>
      ) : (
        <ul className="mt-4 space-y-2 max-w-md mx-auto">
          {history.map((h) => (
            <li
              key={h.at}
              data-testid="storm-history-entry"
              className="flex items-center gap-2 text-sm text-zinc-400 border-b border-[#9945FF]/15 pb-2"
            >
              <span className="text-[#00FFD1]">⚡</span>
              <span>
                <span className="gradient-sol font-bebas text-base tracking-widest">{h.tierName}</span>
                {" hit on "}
                <span className="text-zinc-300">{fmtTime(h.at).date}</span>
                {" at "}
                <span className="text-zinc-300">{fmtTime(h.at).time}</span>
                {" · "}
                <span className="text-zinc-300">{fmtVol(h.volume)} vol</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
